var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.path,{tag:"component",staticClass:"cursor-select",attrs:{"item":_vm.item,"keys":_vm.keys,"state":_vm.state}})}
var staticRenderFns = []

export { render, staticRenderFns }